(function () {
  function initProductAccordion(root) {
    if (!root || root.dataset.accordionInitialized === 'true') return;

    root.dataset.accordionInitialized = 'true';

    const keepOneOpen = root.dataset.keepOneAccordionOpen === 'true';

    if (!keepOneOpen) return;

    const getDetails = () =>
      Array.from(root.querySelectorAll('details[data-product-accordion]'));

    root.addEventListener('toggle', function (event) {
      const details = event.target;

      if (
        !(details instanceof HTMLDetailsElement) ||
        !details.matches('[data-product-accordion]')
      ) {
        return;
      }

      const all = getDetails();

      if (details.open) return;

      const anotherOpen = all.some(
        (item) => item !== details && item.open
      );

      if (!anotherOpen && all.length) {
        details.open = true;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(initProductAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();